import React, { useState } from 'react';
import { X } from 'lucide-react';
const handleContactClick = () => {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', 'Contact', {});
      console.log('✅ Contact event tracked');
    }
  } catch (error) {
    console.error('❌ Error tracking contact click:', error);
  }
};
const handlePopupOpen = (popupType: string) => {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('trackCustom', 'PopupOpened', {
        popup_type: popupType
      });
      console.log(`✅ Popup opened: ${popupType}`);
    }
  } catch (error) {
    console.error('❌ Error tracking popup open:', error);
  }
};
const handleFormSubmit = (e: React.FormEvent) => {
  e.preventDefault();
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', 'Lead', {
        content_name: 'Contact Form Submission'
      });
      console.log('✅ Lead event tracked');
    }
  } catch (error) {
    console.error('❌ Error tracking form submission:', error);
  }
  alert('Gracias por tu mensaje. Te responderemos pronto.');
};
export function Footer() {
  const [activePopup, setActivePopup] = useState<string | null>(null);
  const openPopup = (popupName: string) => {
    setActivePopup(popupName);
    document.body.style.overflow = 'hidden';
    if (popupName === 'contact') {
      handleContactClick();
    }
    handlePopupOpen(popupName);
  };
  const closePopup = () => {
    setActivePopup(null);
    document.body.style.overflow = 'auto';
  };
  return <footer className="bg-amber-900 text-amber-200 py-8" data-id="element-124">
      <div className="container mx-auto px-4 md:px-6" data-id="element-125">
        <div className="max-w-5xl mx-auto" data-id="element-126">
          <div className="flex flex-col md:flex-row justify-between items-center mb-8" data-id="element-127">
            <div className="mb-4 md:mb-0" data-id="element-128">
              <h2 className="text-xl font-bold text-white" data-id="element-129">Cría con calma</h2>
              <p className="text-amber-300 text-sm mt-1" data-id="element-130">
                Rutinas visuales + límites amables
              </p>
            </div>
            <div className="flex flex-wrap gap-6 justify-center" data-id="element-131">
              <button onClick={() => openPopup('privacy')} className="text-amber-200 hover:text-white" data-id="element-132">
                Privacidad
              </button>
              <button onClick={() => openPopup('terms')} className="text-amber-200 hover:text-white" data-id="element-133">
                Términos y Condiciones
              </button>
              <button onClick={() => openPopup('contact')} className="text-amber-200 hover:text-white" data-id="element-134">
                Contacto
              </button>
            </div>
          </div>
          <div className="border-t border-amber-800 pt-6 text-center text-sm" data-id="element-135">
            <p data-id="element-136">&copy; 2023 Cría con calma. Todos los derechos reservados.</p>
          </div>
        </div>
      </div>
      {/* Privacy Policy Popup */}
      {activePopup === 'privacy' && <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" data-id="element-137">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto text-amber-900 p-6 relative" data-id="element-138">
            <button onClick={closePopup} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" data-id="element-139">
              <X size={24} data-id="element-140" />
            </button>
            <h2 className="text-2xl font-bold mb-4 font-serif" data-id="element-141">
              Política de Privacidad
            </h2>
            <div className="space-y-4 text-left" data-id="element-142">
              <p data-id="element-143">Última actualización: 1 de octubre de 2023</p>
              <h3 className="text-lg font-bold" data-id="element-144">
                1. Información que recopilamos
              </h3>
              <p data-id="element-145">
                En Cría con calma, recopilamos información personal que usted
                nos proporciona directamente, como nombre, dirección de correo
                electrónico, información de pago y cualquier otra información
                que elija proporcionar cuando utiliza nuestros servicios, se
                registra en nuestro sitio web o se comunica con nosotros.
              </p>
              <h3 className="text-lg font-bold" data-id="element-146">
                2. Cómo utilizamos su información
              </h3>
              <p data-id="element-147">
                Utilizamos la información que recopilamos para proporcionar,
                mantener y mejorar nuestros servicios, procesar transacciones,
                enviar comunicaciones relacionadas con nuestros servicios, y
                para otros fines descritos al momento de la recopilación.
              </p>
              <h3 className="text-lg font-bold" data-id="element-148">3. Compartir información</h3>
              <p data-id="element-149">
                No vendemos ni alquilamos su información personal a terceros.
                Podemos compartir su información con proveedores de servicios
                que trabajan en nuestro nombre para ayudarnos a operar nuestro
                negocio y prestar servicios.
              </p>
              <h3 className="text-lg font-bold" data-id="element-150">4. Seguridad</h3>
              <p data-id="element-151">
                Implementamos medidas de seguridad diseñadas para proteger su
                información personal, pero no podemos garantizar que su
                información esté completamente segura contra accesos no
                autorizados.
              </p>
              <h3 className="text-lg font-bold" data-id="element-152">5. Sus derechos</h3>
              <p data-id="element-153">
                Dependiendo de su ubicación, puede tener derechos relacionados
                con sus datos personales, como el derecho a acceder, corregir,
                eliminar o restringir el procesamiento de su información
                personal.
              </p>
              <h3 className="text-lg font-bold" data-id="element-154">6. Cambios a esta política</h3>
              <p data-id="element-155">
                Podemos actualizar esta política de privacidad de vez en cuando.
                Le notificaremos cualquier cambio publicando la nueva política
                de privacidad en esta página.
              </p>
              <h3 className="text-lg font-bold" data-id="element-156">7. Contáctenos</h3>
              <p data-id="element-157">
                Si tiene preguntas sobre esta política de privacidad, por favor
                contáctenos a: privacidad@criaconcalma.com
              </p>
            </div>
          </div>
        </div>}
      {/* Terms and Conditions Popup */}
      {activePopup === 'terms' && <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" data-id="element-158">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto text-amber-900 p-6 relative" data-id="element-159">
            <button onClick={closePopup} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" data-id="element-160">
              <X size={24} data-id="element-161" />
            </button>
            <h2 className="text-2xl font-bold mb-4 font-serif" data-id="element-162">
              Términos y Condiciones
            </h2>
            <div className="space-y-4 text-left" data-id="element-163">
              <p data-id="element-164">Última actualización: 1 de octubre de 2023</p>
              <h3 className="text-lg font-bold" data-id="element-165">
                1. Aceptación de los términos
              </h3>
              <p data-id="element-166">
                Al acceder y utilizar nuestro sitio web y nuestros servicios,
                usted acepta estar sujeto a estos Términos y Condiciones. Si no
                está de acuerdo con alguna parte de estos términos, no podrá
                acceder a nuestros servicios.
              </p>
              <h3 className="text-lg font-bold" data-id="element-167">2. Uso del servicio</h3>
              <p data-id="element-168">
                Nuestros servicios y contenidos están destinados únicamente para
                uso personal y no comercial. No puede modificar, copiar,
                distribuir, transmitir, mostrar, realizar, reproducir, publicar,
                licenciar, crear trabajos derivados, transferir o vender
                cualquier información obtenida de nuestro sitio web sin nuestro
                consentimiento previo por escrito.
              </p>
              <h3 className="text-lg font-bold" data-id="element-169">3. Compras y pagos</h3>
              <p data-id="element-170">
                Al realizar una compra, usted acepta proporcionar información de
                compra actual, completa y precisa. Nos reservamos el derecho de
                rechazar o cancelar su pedido en cualquier momento por razones
                que incluyen, entre otras, la disponibilidad del producto o
                servicio, errores en la descripción o precio, o sospecha de
                fraude.
              </p>
              <h3 className="text-lg font-bold" data-id="element-171">4. Propiedad intelectual</h3>
              <p data-id="element-172">
                Todo el contenido incluido en nuestro sitio web y productos,
                como texto, gráficos, logotipos, imágenes, así como su
                compilación, es propiedad de Cría con calma y está protegido por
                leyes de derechos de autor y propiedad intelectual.
              </p>
              <h3 className="text-lg font-bold" data-id="element-173">5. Garantía y devoluciones</h3>
              <p data-id="element-174">
                Ofrecemos una garantía de satisfacción de 7 días en todos
                nuestros productos digitales. Si no está satisfecho con su
                compra, puede solicitar un reembolso completo dentro de los 7
                días posteriores a la compra.
              </p>
              <h3 className="text-lg font-bold" data-id="element-175">
                6. Limitación de responsabilidad
              </h3>
              <p data-id="element-176">
                En ningún caso Cría con calma, sus directores, empleados o
                agentes serán responsables por cualquier daño directo,
                indirecto, incidental, especial o consecuente que resulte del
                uso o la incapacidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-bold" data-id="element-177">7. Cambios a los términos</h3>
              <p data-id="element-178">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. Le notificaremos sobre cualquier cambio
                publicando los nuevos términos en nuestro sitio web.
              </p>
            </div>
          </div>
        </div>}
      {/* Contact Popup with form submission tracking */}
      {activePopup === 'contact' && <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" data-id="element-179">
          <div className="bg-white rounded-lg max-w-md w-full text-amber-900 p-6 relative" data-id="element-180">
            <button onClick={closePopup} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" data-id="element-181">
              <X size={24} data-id="element-182" />
            </button>
            <h2 className="text-2xl font-bold mb-4 font-serif" data-id="element-183">Contacto</h2>
            <div className="space-y-4" data-id="element-184">
              <p data-id="element-185">Estamos aquí para ayudarte. Ponte en contacto con nosotros:</p>
              <div data-id="element-186">
                <h3 className="font-medium" data-id="element-187">Correo electrónico:</h3>
                <p data-id="element-188">globalbooksmkt@gmail.com</p>
              </div>
              <div data-id="element-189">
                <h3 className="font-medium" data-id="element-190">Horario de atención:</h3>
                <p data-id="element-191">Lunes a viernes: 9:00 AM - 6:00 PM (CET)</p>
              </div>
              <form className="space-y-4 mt-6" onSubmit={handleFormSubmit} data-id="element-192">
                <div data-id="element-193">
                  <label htmlFor="name" className="block text-sm font-medium text-amber-900 mb-1" data-id="element-194">
                    Nombre
                  </label>
                  <input type="text" id="name" required className="w-full px-3 py-2 border border-amber-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" placeholder="Tu nombre" data-id="element-195" />
                </div>
                <div data-id="element-196">
                  <label htmlFor="email" className="block text-sm font-medium text-amber-900 mb-1" data-id="element-197">
                    Correo electrónico
                  </label>
                  <input type="email" id="email" required className="w-full px-3 py-2 border border-amber-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" placeholder="tu@email.com" data-id="element-198" />
                </div>
                <div data-id="element-199">
                  <label htmlFor="message" className="block text-sm font-medium text-amber-900 mb-1" data-id="element-200">
                    Mensaje
                  </label>
                  <textarea id="message" rows={4} required className="w-full px-3 py-2 border border-amber-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" placeholder="¿En qué podemos ayudarte?" data-id="element-201"></textarea>
                </div>
                <button type="submit" className="w-full bg-amber-700 hover:bg-amber-800 text-white font-medium py-2 px-4 rounded-md" data-id="element-202">
                  Enviar mensaje
                </button>
              </form>
            </div>
          </div>
        </div>}
    </footer>;
}